import React from 'react';
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  IconButton,
  useTheme,
} from '@mui/material';
import {
  Email,
  Phone,
  LinkedIn,
  School,
} from '@mui/icons-material';

const Faculty = () => {
  const theme = useTheme();

  const facultyMembers = [
    {
      name: "Dr. Shrwan Ram",
      position: "Head & Professor",
    //   email: "Shrwan.cse@mbm.ac.in",
      phone: "",
      research: [
        "Artificial Intelligence and Machine Learning",
        "Internet of Things",
        "Image and Signal Processing",
        "Computer Vision",
        "Computer Networks",
        "Cloud Computing"
      ],
      image: "/imgf2.jpg"
    },
    {
      name: "Dr. N.C. Barwar",
      position: "Professor",
    //   email: "nemi.cse@mbm.ac.in",
    //   phone: "",
      research: [
        "Wireless Sensor Networks",
        "Natural Language Processing",
        "Internet of Things",
        "Deep Learning"
      ],
      image: "/imgf.jpg"
    },
    {
      name: "Dr. Anil Gupta",
      position: "Professor",
    //   email: "anil.cse@mbm.ac.in",
    //   phone: "",
      research: [],
      image: "/imgf5.jpg"
    },
    {
      name: "Dr. Alok Singh Gahlot",
      position: "Assistant Professor, In-charge Embedded Systems and Robotics Club",
    //   email: "alok.cse@mbm.ac.in",
    //   phone: "950-977-9717",
      research: [
        "Robotics",
        "Embedded Systems",
        "Internet of things applications",
        "Industrial Microcontroller programming",
        "Mathematical modelling",
        "Machine learning"
      ],
      image: "/imgf3.jpg"
    },
    {
      name: "Dr. Simran Choudhary",
      position: "Assistant Professor",
    //   email: "Simran.cse@mbm.ac.in",
    //   phone: "",
      research: [],
      image: "/imgf4.jpg"
    },
    {
      name: "Sh. Abhisek Gour",
      position: "Assistant Professor",
    //   email: "abhisek.cse@mbm.ac.in",
    //   phone: "",
      research: [
        "Artificial Intelligence",
        "Data Analytics",
        "Software Engineering",
        "Entrepreneurship"
      ],
      image: "/imgf1.jpg"
    }
  ];

  return (
    <Box sx={{ 
      py: { xs: 4, md: 8 },
      background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)',
      minHeight: '100vh'
    }}>
      <Container maxWidth="lg">
        <Typography variant="h3" align="center" gutterBottom sx={{ 
          mb: 8,
          color: 'primary.main',
          fontWeight: 800,
          fontSize: { xs: '2rem', md: '2.5rem' },
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -16,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 80,
            height: 4,
            background: 'linear-gradient(90deg, #1a237e 0%, #c62828 100%)',
            borderRadius: 2
          }
        }}>
          Our Faculty
        </Typography>

        <Grid container spacing={4}>
          {facultyMembers.map((faculty, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card sx={{ 
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                borderRadius: 4,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                }
              }}>
                <CardContent sx={{ p: 4 }}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                      <Box sx={{ 
                        width: '100%', 
                        aspectRatio: '1/1',
                        borderRadius: 2, 
                        overflow: 'hidden', 
                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)', 
                        bgcolor: 'grey.100', 
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <img
                          src={faculty.image}
                          alt={faculty.name}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center',
                            background: '#f4f6fa',
                            display: 'block',
                            maxWidth: '100%',
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '/faculty/imgf.jpg'; // Fallback image
                          }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="h5" gutterBottom sx={{ 
                        fontWeight: 700,
                        color: 'primary.main'
                      }}>
                        {faculty.name}
                      </Typography>
                      <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                        {faculty.position}
                      </Typography>
                      
                      <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                        {faculty.phone && (
                          <IconButton 
                            size="small" 
                            href={`tel:${faculty.phone}`}
                            sx={{ 
                              color: 'primary.main',
                              '&:hover': { color: 'primary.dark' }
                            }}
                          >
                            <Phone />
                          </IconButton>
                        )}
                      </Box>

                      {faculty.research.length > 0 && (
                        <>
                          <Typography variant="subtitle2" sx={{ 
                            fontWeight: 600,
                            mb: 1,
                            color: 'text.secondary'
                          }}>
                            Research Areas:
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            {faculty.research.map((area, idx) => (
                              <Chip
                                key={idx}
                                label={area}
                                size="small"
                                sx={{
                                  background: 'linear-gradient(45deg, rgba(26,35,126,0.1) 0%, rgba(198,40,40,0.1) 100%)',
                                  color: 'primary.main',
                                  fontWeight: 500,
                                  '&:hover': {
                                    background: 'linear-gradient(45deg, rgba(26,35,126,0.15) 0%, rgba(198,40,40,0.15) 100%)',
                                  }
                                }}
                              />
                            ))}
                          </Box>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Faculty; 